export default __webpack_public_path__ + "static/media/comunity.a468d1e3.svg";